import { TaskType } from 'app/constants/taskType'
import { useTaskTrackerStore } from '@/modules/shared/stores/taskTrackerStore'

/**
 * Rejestruje zadanie do śledzenia.
 *
 * Pisze do `taskTrackerStore`. Funkcja zostaje, bo kilka ekranów (wydruki, kreator,
 * dialog co-drivera) rejestruje zadania z pominięciem `useTask()` - przepięcie samego
 * kontekstu sprawiło, że ich zadania nie trafiały nigdzie: raport powstawał na
 * serwerze, ale podgląd nigdy się nie otwierał, bo nikt nie wiedział, że jest na co
 * czekać.
 *
 * companyId bierzemy z URL-a; dawny zapas czytał wybór firmy z reduxa, którego
 * już nie ma.
 */
export const addTask = (id: string, type: TaskType, data: any): void => {
  const fromUrl = /\/company\/([0-9a-fA-F-]{36})(?:\/|$)/.exec(
    typeof window !== 'undefined' ? window.location.pathname : '',
  )

  useTaskTrackerStore
    .getState()
    .track({ id, companyId: fromUrl?.[1] ?? '', type, data })
}
